<div
  class="p-3 px-md-4 mb-3 bg-dfs-purple border-bottom shadow-sm">
  <div class="d-flex flex-column flex-md-row align-items-center" [ngClass]="{'navbar': isAuthenticated}">
    <span class="logo-img"></span>
    <h5 class="my-0 fw-normal text-white float-start mb-1 me-3">
      <a routerLink="/stores" class="btn-link" (click)="unselectStore()">Rota</a>
    </h5>
    @if (isAuthenticated) {
      <div class="store-search">
        <app-store-search [selectedStore]="dataService.selectedStore"></app-store-search>
      </div>
    }
    @if (isAuthenticated) {
      <ul class="navbar-nav bd-navbar-nav flex-row ms-auto me-auto">
        @if (showPage(Authority.AUTH_SEE_USERS)) {
          <li class="nav-item">
            <a routerLink="/users"
              routerLinkActive="active-link"
            class="btn btn-link">Users</a>
          </li>
        }
        @if (showPage(Authority.AUTH_SEE_USERS)) {
          <li class="nav-item">
            <a routerLink="/user-statistics"
              routerLinkActive="active-link"
            class="btn btn-link">Statistics</a>
          </li>
        }
        @if (showPage(Authority.AUTH_MANAGE_USER_ACCESS)) {
          <li class="nav-item">
            <a routerLink="/permissions"
              routerLinkActive="active-link"
            class="btn btn-link">Permissions</a>
          </li>
        }
        @if (showPage(Authority.AUTH_PERFORM_ADMINISTRATION)) {
          <li class="nav-item">
            <a routerLink="/admin-debug"
              routerLinkActive="active-link"
            class="btn btn-link">Admin</a>
          </li>
        }
      </ul>
    }
    @if (isAuthenticated) {
      <ul class="navbar-nav bd-navbar-nav flex-row ms-auto">
        <li class="nav-item">
          <i (click)="onLogout()" class="fa fa-sign-out-alt fa-lg ms-3 mb-3 pointer" aria-hidden="true"></i>
        </li>
      </ul>
    }
  </div>
</div>
@if (isAuthenticated && showPage(Authority.AUTH_SEE_SPECIFIC_STORES)) {
  <app-rule-checker></app-rule-checker>
}
